export const validateClipboardInput = (input) =>
   /^[A-Za-z0-9/\-\t\r\n\s:]*$/.test(input);

export const validateAlphanumericText = (input) => /^[a-zA-Z0-9]+$/.test(input);

export const validateAlphanumericWithUnderscoreText = (input) =>
   /^[a-zA-Z0-9_]+$/.test(input);

export const validateAlphaText = (input) => /^[a-zA-Z]+$/.test(input);

export const validateNumericText = (input) => /^[0-9]+$/.test(input);

export const validateMathOperators = (input) => /^[0-9+\-*/=.]+$/.test(input);

export const searchCriteriaFieldsValidation = {
   NUMERIC: /^[0-9\s%_,]+$/,
   NUMERIC_WITH_DECIMAL: /^[0-9\s%_,.]+$/,
   AMOUNT: /^[\d.\d\s%_]*$/,
   DOW: /^[a-zA-Z0-9\s%_|,]+$/,
   ALPHA: /^[a-zA-Z\s%_,]+$/,
   ALPHA_NUMERIC: /^[a-zA-Z0-9\s%_,]+$/,
   DATE_STRING: /^[a-zA-Z0-9\s%_:,]+$/,
   ALPHA_NUMERIC_WITH_PIPE: /^[a-zA-Z0-9\s%_|,-]+$/,
   ALPHA_NUMERIC_WITH_STAR: /^[a-zA-Z0-9\s%_,*]+$/,
   ALPHA_NUMERIC_WITH_ATPCO_WILD_CARDS: /^[a-zA-Z0-9\s%_,!&-]+$/,
   SPECIAL_CHAR: /^[=:&/*%_,]+$/,
};
